// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a02a7e64","879":"ba583311"}[chunkId] + ".chunk.js";
};